import { render, staticRenderFns } from "./SelectCompany.vue?vue&type=template&id=53132dff&scoped=true&"
import script from "./SelectCompany.vue?vue&type=script&lang=js&"
export * from "./SelectCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53132dff",
  null
  
)

export default component.exports